import { createContext } from "react";

interface TabContentContextValue {
  $bs_tabContent?: {
    bsClass?: string;
    animation?: boolean | any;
    activeKey?: any;
    mountOnEnter?: boolean;
    unmountOnExit?: boolean;
    onPaneEnter?: (child: any, childKey: any) => boolean;
    onPaneExited?: (child: any) => void;
    exiting?: boolean;
  };
}

const TabContentContext = createContext<TabContentContextValue>({});

export default TabContentContext;
